module.exports = __webpack_public_path__ + "media/assets/images/tour/5c_Tour_3-85f8fdb311e54d2aaa24d187070c91ce.png";